import React from 'react';
import { FormattedMessage, useIntl, } from 'react-intl';
import { Button, Col, Modal, Row, } from '@folio/stripes/components';
import { ModalFooter } from '@folio/stripes-acq-components';
export var MarkUnreceivableModal = function (_a) {
    var claimsCount = _a.claimsCount, disabled = _a.disabled, onCancel = _a.onCancel, onSubmit = _a.onSubmit, open = _a.open;
    var intl = useIntl();
    var modalLabel = intl.formatMessage({ id: 'ui-claims.claiming.markUnreceivable.modal.heading' });
    var start = (React.createElement(Button, { marginBottom0: true, onClick: onCancel },
        React.createElement(FormattedMessage, { id: "stripes-acq-components.FormFooter.cancel" })));
    var end = (React.createElement(Button, { buttonStyle: "primary", disabled: disabled, onClick: onSubmit, marginBottom0: true },
        React.createElement(FormattedMessage, { id: "stripes-acq-components.FormFooter.save" })));
    var footer = (React.createElement(ModalFooter, { renderStart: start, renderEnd: end }));
    return (React.createElement(Modal, { open: open, id: "mark-unreceivable-modal", size: "small", footer: footer, label: modalLabel, "aria-label": modalLabel },
        React.createElement(Row, null,
            React.createElement(Col, { xs: true },
                React.createElement(FormattedMessage, { id: "ui-claims.claiming.markUnreceivable.modal.message", values: { count: claimsCount } })))));
};
